import {useContext, useEffect, useMemo, useState} from "react";
import { Context } from "../..";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import Modal from "../Modal/Modal";
import ModalBody from '../UI/ModalBody/ModalBody';
import ModalPanel from "../UI/ModalPanel/ModalPanel";
import DeliveryForm from "./DeliveryForm";
import DeliveryMap from "./DeliveryMap";

export default function DeliveryModal({
    isModalOpen,
    closeModal,
    preorderMode = false
}) {
    const { delivery } = useContext(Context)
    const isTablet = useMediaQuery('(max-width: 992px)')
    const [searchAddress, setSearchAddress] = useState(false);

    const selectAddress = function(){
        setSearchAddress(delivery.searchAddress.value);
    }

    return <>
        {isModalOpen && <Modal modalClassName="delivery-modal" onClose={closeModal}>
                <ModalBody>
                    <div className="shipping-modal-wrapper">
                        <div className="shipping-modal-header">
                                <button
                                    className="mini-header__button"
                                    type="button"
                                    onClick={closeModal}
                                >
                                    <svg
                                        width="40"
                                        height="40"
                                        viewBox="0 0 40 40"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <g opacity="0.8">
                                        <path
                                            d="M26.25 32.5L13.75 20L26.25 7.5"
                                            stroke="#1B1B1B"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                    </svg>
                                </button>
                                <span className="shipping-modal-header-name">Адрес доставки</span>
                            </div>
                        <div className="shipping-modal-wrapper__main">
                            <DeliveryMap handleSelectAddress={selectAddress}/>
                        </div>

                        <div className="shipping-modal-wrapper__aside">
                            <ModalPanel title="Адрес доставки" onClose={closeModal}>
                                <DeliveryForm onSubmitCallback={closeModal} withSelectCity preorderMode={preorderMode} />
                            </ModalPanel>
                        </div>

                    </div>
                </ModalBody>
            </Modal>}
    </>
}
